import React, { Component } from "react";
import {
  Breadcrumb,
  Container,
  Header,
  List,
  Menu,
  Segment,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";

class ReservationsView extends Component {
  render() {
    // eslint-disable-next-line
    const { t } = this.props;

    return (
      <Container>
        <Menu
          inverted
          style={{ backgroundColor: "#136444", borderRadius: 0, margin: 0 }}
        >
          <Menu.Item name="inicio" active={false} />
          <Menu.Item name="nosotros" active={false} />
          <Menu.Item name="mis reservas" active={true} />
          <Menu.Item name="mi saldo" active={false} />
        </Menu>

        <Segment vertical secondary style={{ padding: 4 }}>
          <Breadcrumb>
            <Breadcrumb.Section as={Link} link to={"/"}>
              Inicio
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section as={Link} link to={"/reservations"}>
              Reservas
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section active>#1</Breadcrumb.Section>
          </Breadcrumb>
        </Segment>

        <Segment vertical>
          <Header as="h3">
            <Header.Content>
              RESERVA #1
              <Header.Subheader>Detalles de la reserva</Header.Subheader>
            </Header.Content>
          </Header>
        </Segment>

        <Segment vertical>
          <List divided relaxed>
            <List.Item>
              <List.Content>
                <List.Header>Producto</List.Header>
                <List.Description>Cancha Tenis 1</List.Description>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <List.Header>Fecha y Hora de Reserva</List.Header>
                <List.Description>01/02/2018 18:30</List.Description>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <List.Header>Fecha de realizacion</List.Header>
                <List.Description>01/01/2018 12:47</List.Description>
              </List.Content>
            </List.Item>
          </List>
        </Segment>
      </Container>
    );
  }
}

const i18nEnhancement = translate("translations")(ReservationsView);

export default i18nEnhancement;



// WEBPACK FOOTER //
// ./src/components/views/reservations/ReservationDetailView.jsx